import { render, staticRenderFns } from "./UserConfigsMenu.vue?vue&type=template&id=f5d1f814&scoped=true&"
import script from "./UserConfigsMenu.vue?vue&type=script&lang=js&"
export * from "./UserConfigsMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserConfigsMenu.vue?vue&type=style&index=0&id=f5d1f814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d1f814",
  null
  
)

export default component.exports